/**
 * SGC Organogram — built incrementally from official organogram.
 * Source of truth: server/data/sgc-org-chart-default.json
 */

export const SGC_ORG_CHART = {
  "id": "president-sardar-tanveer-ilyas",
  "title": "President",
  "name": "Sardar Tanveer Ilyas",
  "type": "patron",
  "isVacant": false,
  "children": [
    {
      "id": "patron-in-chief-education",
      "title": "Patron-in-Chief (Education)",
      "name": "Admiral Abdul Aziz Mirza (Retd)",
      "type": "patron",
      "isVacant": false,
      "children": []
    },
    {
      "id": "president-steering-committee-chairman",
      "title": "President Steering Committee for Strategic Direction, Evaluation & Monitoring and Chairman of the Board",
      "name": "Vice Admiral Ahmad Tasnim (Retd)",
      "type": "patron",
      "isVacant": false,
      "children": [
        {
          "id": "project-management-company",
          "title": "Project Management Company",
          "name": "",
          "type": "project",
          "isVacant": false,
          "children": [
            {
              "id": "ceo-241",
              "title": "CEO",
              "name": "",
              "type": "management",
              "isVacant": true,
              "children": [
                {
                  "id": "pcs-manager-350",
                  "title": "PCS Manager",
                  "name": "currently work CEO",
                  "type": "management",
                  "isVacant": false,
                  "children": [
                    {
                      "id": "contract-manager-355",
                      "title": "Contract Manager",
                      "name": "",
                      "type": "management",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "sr-estimator-356",
                          "title": "Sr. Estimator",
                          "name": "",
                          "type": "management",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "estimator-357",
                              "title": "Estimator",
                              "name": "Sattar",
                              "type": "staff",
                              "isVacant": false,
                              "children": []
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "sr-planning-engr-348",
                      "title": "Sr. Planning Engr.",
                      "name": "",
                      "type": "management",
                      "isVacant": true,
                      "children": [
                        {
                          "id": "planning-engr-352",
                          "title": "Planning Engr.",
                          "name": "Fut.",
                          "type": "staff",
                          "isVacant": true,
                          "children": [
                            {
                              "id": "risk-mgt-engr-351",
                              "title": "Risk Mgt Engr.",
                              "name": "",
                              "type": "staff",
                              "isVacant": false,
                              "children": []
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "sr-pm-supervision-347",
                  "title": "Sr. PM Supervision",
                  "name": "Zia ullah Khan",
                  "type": "management",
                  "isVacant": false,
                  "children": [
                    {
                      "id": "sr-architect-343",
                      "title": "Sr. Architect",
                      "name": "Umair",
                      "type": "management",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "draftsman-353",
                          "title": "Draftsman",
                          "name": "Sajad Ali",
                          "type": "staff",
                          "isVacant": false,
                          "children": []
                        }
                      ]
                    },
                    {
                      "id": "office-engr-344",
                      "title": "Office Engr.",
                      "name": "Asfandyar Khan",
                      "type": "management",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "sr-sqs-345",
                          "title": "Sr. SQS",
                          "name": "Shahzad",
                          "type": "management",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "q-surveyor-346",
                              "title": "Q. Surveyor",
                              "name": "Satar",
                              "type": "staff",
                              "isVacant": false,
                              "children": []
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "cm-road-earthwork-358",
                      "title": "CM Road & Earthwork",
                      "name": "Abrar Ullah",
                      "type": "management",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "cm-mechnical-359",
                          "title": "CM Mechnical",
                          "name": "Malik Zahid",
                          "type": "management",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "cm-electrical-360",
                              "title": "CM Electrical",
                              "name": "",
                              "type": "management",
                              "isVacant": true,
                              "children": []
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "qa-qc-engineer-349",
                      "title": "QA/QC Engineer",
                      "name": "Tahir Akbar",
                      "type": "management",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "material-eng-354",
                          "title": "Material Eng.",
                          "name": "Tayab Sabir",
                          "type": "staff",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "officer-hse-362",
                              "title": "Officer HSE",
                              "name": "Tariq Aziz Baig",
                              "type": "staff",
                              "isVacant": false,
                              "children": []
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "id": "business-project-1-taj-residencia",
          "title": "Business Project-1 TAJ RESIDENCIA",
          "name": "",
          "type": "project",
          "isVacant": false,
          "children": [
            {
              "id": "coo-projects-business-development-taj",
              "title": "COO PROJECTS & Business Development",
              "name": "",
              "type": "management",
              "isVacant": true,
              "children": []
            },
            {
              "id": "gm-admin-procurement-taj",
              "title": "GM Admin & Procurement",
              "name": "M. Nawaz Janjua",
              "type": "management",
              "isVacant": false,
              "children": []
            },
            {
              "id": "taj-procurement-dept",
              "title": "Procurement",
              "name": "",
              "type": "department",
              "isVacant": false,
              "children": [
                {
                  "id": "taj-procurement-sr-manager-mishal",
                  "title": "Sr. Manager",
                  "name": "Mishal Younas",
                  "type": "management",
                  "isVacant": false,
                  "children": [
                    {
                      "id": "taj-procurement-manager-talha",
                      "title": "Manager",
                      "name": "M. Talha",
                      "type": "management",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-procurement-manager-nadeem",
                          "title": "Manager",
                          "name": "Nadeem",
                          "type": "management",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-procurement-am-haris",
                              "title": "Assistant Manager",
                              "name": "Haris",
                              "type": "management",
                              "isVacant": false,
                              "children": [
                                {
                                  "id": "taj-procurement-sr-executive-hamza",
                                  "title": "Sr. Executive",
                                  "name": "Hamza",
                                  "type": "staff",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-procurement-assistant-sup-gull",
                                      "title": "Assistant Sup.",
                                      "name": "Gull Rehman",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": [
                                        {
                                          "id": "taj-procurement-helper-tariq",
                                          "title": "Helper purchase",
                                          "name": "M. Tariq",
                                          "type": "staff",
                                          "isVacant": false,
                                          "children": []
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "id": "taj-store-dept",
              "title": "Store",
              "name": "",
              "type": "department",
              "isVacant": false,
              "children": [
                {
                  "id": "taj-store-am-keeper-raja",
                  "title": "AM Store Keeper",
                  "name": "Raja Tariq",
                  "type": "management",
                  "isVacant": false,
                  "children": [
                    {
                      "id": "taj-store-am-procurement-zahid",
                      "title": "AM Store / Procurement",
                      "name": "Zahid Ahmed",
                      "type": "management",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-store-am-usman",
                          "title": "Assistant Manager",
                          "name": "Muhammad Usman",
                          "type": "management",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-store-intern-ayaz",
                              "title": "Intern",
                              "name": "Ayaz (Royal Crete)",
                              "type": "staff",
                              "isVacant": false,
                              "children": [
                                {
                                  "id": "taj-store-intern-suliman",
                                  "title": "Intern",
                                  "name": "Suliman",
                                  "type": "staff",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-store-helper-np",
                                      "title": "Non Permanent Store Helper",
                                      "name": "(1)",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": []
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "id": "taj-admin-dept",
              "title": "Admin",
              "name": "",
              "type": "department",
              "isVacant": false,
              "children": [
                {
                  "id": "taj-admin-officer-saqib",
                  "title": "Officer Admin",
                  "name": "Saqib Javed",
                  "type": "management",
                  "isVacant": false,
                  "children": []
                },
                {
                  "id": "taj-admin-dr-drivers",
                  "title": "DR (1), Driver (8), Office Boy (2)",
                  "name": "",
                  "type": "staff",
                  "isVacant": false,
                  "children": []
                },
                {
                  "id": "taj-admin-supervisor-ijaz",
                  "title": "Supervisor",
                  "name": "Mr. Ijaz",
                  "type": "management",
                  "isVacant": false,
                  "children": []
                },
                {
                  "id": "taj-admin-support-staff-np",
                  "title": "Non Permanent Support Staff",
                  "name": "(7)",
                  "type": "staff",
                  "isVacant": false,
                  "children": []
                }
              ]
            },
            {
              "id": "taj-workshop-dept",
              "title": "Workshop",
              "name": "",
              "type": "department",
              "isVacant": false,
              "children": [
                {
                  "id": "taj-workshop-incharge-asad",
                  "title": "In charge Workshop",
                  "name": "Muhammad Asad Chughtaie",
                  "type": "management",
                  "isVacant": false,
                  "children": [
                    {
                      "id": "taj-workshop-am-farhad",
                      "title": "AM",
                      "name": "Farhad",
                      "type": "management",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-workshop-coordinator-mushtaq",
                          "title": "Coordinator",
                          "name": "Mushtaq Subhani",
                          "type": "management",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-workshop-supervisor-asif",
                              "title": "Supervisor",
                              "name": "Raja M. Asif",
                              "type": "management",
                              "isVacant": false,
                              "children": [
                                {
                                  "id": "taj-workshop-supervisor-rehan",
                                  "title": "Supervisor",
                                  "name": "Rehan Noor",
                                  "type": "management",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-workshop-mechanic",
                                      "title": "Mechanic",
                                      "name": "(1)",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": [
                                        {
                                          "id": "taj-workshop-helper-mechanic-np",
                                          "title": "Non Permanent Helper Mechanic",
                                          "name": "(1)",
                                          "type": "staff",
                                          "isVacant": false,
                                          "children": []
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "id": "taj-am-coordination",
              "title": "AM Coordination",
              "name": "Chi. Inzimam",
              "type": "management",
              "isVacant": false,
              "children": []
            },
            {
              "id": "taj-information-technology",
              "title": "Information Technology",
              "name": "",
              "type": "department",
              "isVacant": false,
              "children": [
                {
                  "id": "taj-it-sr-manager",
                  "title": "Sr. Manager",
                  "name": "Nasir",
                  "type": "management",
                  "isVacant": false,
                  "children": []
                },
                {
                  "id": "taj-it-technician",
                  "title": "IT Technician",
                  "name": "Jalil Akhtar",
                  "type": "staff",
                  "isVacant": false,
                  "children": []
                },
                {
                  "id": "taj-it-intern",
                  "title": "IT Intern",
                  "name": "Danyal Babar",
                  "type": "staff",
                  "isVacant": false,
                  "children": []
                }
              ]
            },
            {
              "id": "taj-hr-dept",
              "title": "HR",
              "name": "",
              "type": "department",
              "isVacant": false,
              "children": [
                {
                  "id": "taj-executive-hr",
                  "title": "Executive HR – TAJ",
                  "name": "Zubair Ilyas",
                  "type": "management",
                  "isVacant": false,
                  "children": []
                }
              ]
            },
            {
              "id": "taj-agm-muhammad-amjad",
              "title": "AGM",
              "name": "Muhammad Amjad",
              "type": "management",
              "isVacant": false,
              "children": [
                {
                  "id": "taj-post-sales-operation",
                  "title": "Post Sales Operation",
                  "name": "",
                  "type": "department",
                  "isVacant": false,
                  "children": [
                    {
                      "id": "taj-manager-ops-waseem",
                      "title": "Manager Ops",
                      "name": "Waseem",
                      "type": "management",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-legal-wing",
                          "title": "Legal Wing",
                          "name": "",
                          "type": "department",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-law-officer-inhouse",
                              "title": "Law Officer (In-House)",
                              "name": "Asjid Iftikhar",
                              "type": "management",
                              "isVacant": false,
                              "children": []
                            },
                            {
                              "id": "taj-law-officer-field",
                              "title": "Law Officer (Field)",
                              "name": "Jawad",
                              "type": "management",
                              "isVacant": false,
                              "children": []
                            }
                          ]
                        },
                        {
                          "id": "taj-customer-care-dept",
                          "title": "Customer Care",
                          "name": "",
                          "type": "department",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-manager-customer-care",
                              "title": "Manager Customer Care",
                              "name": "Sohail Burki",
                              "type": "management",
                              "isVacant": false,
                              "children": []
                            }
                          ]
                        },
                        {
                          "id": "taj-transfer-possession-dept",
                          "title": "Transfer & Possession",
                          "name": "",
                          "type": "department",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-transfer-am-vacant",
                              "title": "AM",
                              "name": "",
                              "type": "management",
                              "isVacant": true,
                              "children": [
                                {
                                  "id": "taj-officer-transfer-mahnoor",
                                  "title": "Officer Transfer (FO)",
                                  "name": "Miss Mahnoor",
                                  "type": "management",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-executive-bo-asad",
                                      "title": "Executive (BO)",
                                      "name": "Asad Niaz",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": []
                                    }
                                  ]
                                },
                                {
                                  "id": "taj-exec-customer-services-sadiq",
                                  "title": "Executive Customer Services(FO)",
                                  "name": "Mr. Sadiq",
                                  "type": "management",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-coordinator-bo-rooma",
                                      "title": "Coordinator (BO)",
                                      "name": "Rooma Shahid",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": []
                                    }
                                  ]
                                },
                                {
                                  "id": "taj-executive-rameez",
                                  "title": "Executive",
                                  "name": "Rameez",
                                  "type": "management",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-executive-possession-najaf",
                                      "title": "Executive Possession",
                                      "name": "Mr. Najaf",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": []
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "id": "taj-accounts-dept",
                          "title": "Accounts",
                          "name": "",
                          "type": "department",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-am-accounts-arsalan",
                              "title": "AM Accounts",
                              "name": "Mr. Arsalan",
                              "type": "management",
                              "isVacant": false,
                              "children": []
                            },
                            {
                              "id": "taj-accounts-executive-arum",
                              "title": "Accounts Executive",
                              "name": "Arum Shaheen",
                              "type": "staff",
                              "isVacant": false,
                              "children": []
                            }
                          ]
                        },
                        {
                          "id": "taj-sales-ops-inventory-dept",
                          "title": "Sales Ops. Inventory &",
                          "name": "",
                          "type": "department",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-sales-ops-am-zeeshan",
                              "title": "AM",
                              "name": "Zeeshan Ahmad",
                              "type": "management",
                              "isVacant": false,
                              "children": []
                            },
                            {
                              "id": "taj-sales-ops-executive-mubarak",
                              "title": "Executive Sales Ops. & Inventory",
                              "name": "Mubarak Khusro",
                              "type": "staff",
                              "isVacant": false,
                              "children": []
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "id": "taj-master-record-archiving",
                  "title": "Master Record/ Archiving",
                  "name": "",
                  "type": "department",
                  "isVacant": false,
                  "children": [
                    {
                      "id": "taj-master-record-am-kubra",
                      "title": "AM",
                      "name": "Kubra Ali",
                      "type": "management",
                      "isVacant": false,
                      "children": []
                    },
                    {
                      "id": "taj-master-record-executive-sania",
                      "title": "Executive",
                      "name": "Sania",
                      "type": "staff",
                      "isVacant": false,
                      "children": []
                    },
                    {
                      "id": "taj-master-record-officer-rohila",
                      "title": "Officer",
                      "name": "Miss Rohila",
                      "type": "staff",
                      "isVacant": false,
                      "children": []
                    },
                    {
                      "id": "taj-master-record-assistant-nasir",
                      "title": "Record Assistant",
                      "name": "Nasir Saleem",
                      "type": "staff",
                      "isVacant": false,
                      "children": []
                    }
                  ]
                }
              ]
            },
            {
              "id": "taj-sales-dept-new",
              "title": "Sales",
              "name": "",
              "type": "department",
              "isVacant": false,
              "children": [
                {
                  "id": "taj-sales-gm",
                  "title": "General Manager",
                  "name": "Vacant",
                  "type": "management",
                  "isVacant": true,
                  "children": [
                    {
                      "id": "taj-sales-sr-manager-umair",
                      "title": "Sr. Manager Sales",
                      "name": "Umair Khan",
                      "type": "management",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-sales-manager-samra",
                          "title": "Manager Sales",
                          "name": "Samra Yaqoob",
                          "type": "management",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-sales-am-fakhra",
                              "title": "AM",
                              "name": "Syeda Fakhra",
                              "type": "management",
                              "isVacant": false,
                              "children": [
                                {
                                  "id": "taj-sales-exec-shakeel",
                                  "title": "Sales Executive",
                                  "name": "Shakeel",
                                  "type": "staff",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-sales-exec-kashif",
                                      "title": "Sales Executive",
                                      "name": "Kashif Khan",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": [
                                        {
                                          "id": "taj-sales-exec-maryam",
                                          "title": "Sales Executive",
                                          "name": "Maryam shaheen",
                                          "type": "staff",
                                          "isVacant": false,
                                          "children": [
                                            {
                                              "id": "taj-sales-front-desk-kanwal",
                                              "title": "Front Desk Officer",
                                              "name": "Kanwal",
                                              "type": "staff",
                                              "isVacant": false,
                                              "children": [
                                                {
                                                  "id": "taj-sales-officer-manahil",
                                                  "title": "Officer",
                                                  "name": "Miss Manahil",
                                                  "type": "staff",
                                                  "isVacant": false,
                                                  "children": [
                                                    {
                                                      "id": "taj-sales-operator-yasir",
                                                      "title": "Operator",
                                                      "name": "Yasir Saleem",
                                                      "type": "staff",
                                                      "isVacant": false,
                                                      "children": []
                                                    }
                                                  ]
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "id": "taj-arch-design-dept",
              "title": "Architectural Design",
              "name": "",
              "type": "department",
              "isVacant": false,
              "children": [
                {
                  "id": "taj-arch-am-rizwan",
                  "title": "Assistant Manger",
                  "name": "Rizwan",
                  "type": "management",
                  "isVacant": false,
                  "children": [
                    {
                      "id": "taj-arch-cad-adil",
                      "title": "CAD Operator",
                      "name": "Adil",
                      "type": "staff",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-arch-visualizer-haroon",
                          "title": "Visualizer",
                          "name": "Haroon",
                          "type": "staff",
                          "isVacant": false,
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "id": "taj-town-planning-dept",
              "title": "Town Planning/ Building contorl",
              "name": "",
              "type": "department",
              "isVacant": false,
              "children": [
                {
                  "id": "taj-town-sr-planner-atique",
                  "title": "Sr. Town Planner",
                  "name": "Ch. Atique",
                  "type": "management",
                  "isVacant": false,
                  "children": [
                    {
                      "id": "taj-town-sr-inspector-faraz",
                      "title": "Sr. Building Inspector",
                      "name": "Faraz Ahmad",
                      "type": "management",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-town-inspector-amir",
                          "title": "Building Inspector",
                          "name": "Amir Nazir",
                          "type": "staff",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-town-inspector-amjad",
                              "title": "Building Inspector",
                              "name": "Amjad",
                              "type": "staff",
                              "isVacant": false,
                              "children": [
                                {
                                  "id": "taj-town-inspector-aqib",
                                  "title": "Building Inspector",
                                  "name": "Aqib Javeed",
                                  "type": "staff",
                                  "isVacant": false,
                                  "children": []
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "id": "taj-record-transfer-dept",
              "title": "Record & Transfer/ Facility Management",
              "name": "",
              "type": "department",
              "isVacant": false,
              "children": [
                {
                  "id": "taj-record-manager-facilities",
                  "title": "Manager Facilities",
                  "name": "Maj. Zaheer Ahmad (Direct Reporting to GM Procurement)",
                  "type": "management",
                  "isVacant": false,
                  "children": [
                    {
                      "id": "taj-record-security-cctv",
                      "title": "Security and CCTV",
                      "name": "",
                      "type": "department",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-record-security-note",
                          "title": "Taj security will also report to manager facilities",
                          "name": "",
                          "type": "staff",
                          "isVacant": false,
                          "children": []
                        }
                      ]
                    },
                    {
                      "id": "taj-record-horticulture-dept",
                      "title": "Horticulture",
                      "name": "",
                      "type": "department",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-record-horticulture-dm",
                          "title": "DM",
                          "name": "Bilal Kiayani",
                          "type": "management",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-record-horticulture-subdept",
                              "title": "Horticulture",
                              "name": "",
                              "type": "department",
                              "isVacant": false,
                              "children": [
                                {
                                  "id": "taj-record-horticulture-sup",
                                  "title": "Supervisor",
                                  "name": "Muhammad Imtiaz",
                                  "type": "management",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-record-horticulture-gardner",
                                      "title": "Gardner",
                                      "name": "Permanent (15), Non Permanent (08)",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": []
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "taj-record-maint-services-dept",
                      "title": "Maintenance and services department",
                      "name": "",
                      "type": "department",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-record-maint-sup-omais",
                          "title": "Supervisor",
                          "name": "Mr. Omais",
                          "type": "management",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-record-plumbing-dept",
                              "title": "Plumbing & Water Management",
                              "name": "",
                              "type": "department",
                              "isVacant": false,
                              "children": [
                                {
                                  "id": "taj-record-plumbing-sup-semab",
                                  "title": "Supervisor",
                                  "name": "Semab Akhtar",
                                  "type": "management",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-record-plumbing-np",
                                      "title": "Non Permanent",
                                      "name": "Water Bowser Helper (1), Plumber/Wall Man (1), Tube well Optr.(1), Pump operator(1)",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": []
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "id": "taj-record-help-desk-dept",
                              "title": "Help Desk",
                              "name": "",
                              "type": "department",
                              "isVacant": false,
                              "children": [
                                {
                                  "id": "taj-record-help-desk-perm",
                                  "title": "Permanent Complaint Attendant",
                                  "name": "(1)",
                                  "type": "staff",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-record-help-desk-np",
                                      "title": "Non Permanent Complaint Attendant",
                                      "name": "(2)",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": []
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "id": "taj-record-cleaning-dept",
                              "title": "General Cleaning",
                              "name": "",
                              "type": "department",
                              "isVacant": false,
                              "children": [
                                {
                                  "id": "taj-record-cleaning-sup-zafar",
                                  "title": "Supervisor (Road Cleaning)",
                                  "name": "Zafar",
                                  "type": "management",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-record-cleaning-np-road",
                                      "title": "Non Permanent Road Cleaner",
                                      "name": "(5)",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": [
                                        {
                                          "id": "taj-record-cleaning-garbage",
                                          "title": "Garbage Collector",
                                          "name": "(2)",
                                          "type": "staff",
                                          "isVacant": false,
                                          "children": []
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "taj-record-tech-maint-dept",
                      "title": "Technical & Maintenance",
                      "name": "",
                      "type": "department",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-record-electrical-dept",
                          "title": "Electrical",
                          "name": "",
                          "type": "department",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-record-elec-asst-sup-noor",
                              "title": "Assistant Supervisor",
                              "name": "Noor Ahmed",
                              "type": "management",
                              "isVacant": false,
                              "children": [
                                {
                                  "id": "taj-record-elec-ameen",
                                  "title": "Electracian",
                                  "name": "M. Ameen",
                                  "type": "staff",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-record-elec-np",
                                      "title": "Non Permanent Electrician (5)",
                                      "name": "AC Technician (1)",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": []
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "id": "taj-record-civil-dept",
                          "title": "Civil",
                          "name": "",
                          "type": "department",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-record-civil-masson",
                              "title": "Masson (3)",
                              "name": "No- Permanent",
                              "type": "staff",
                              "isVacant": false,
                              "children": [
                                {
                                  "id": "taj-record-civil-labor",
                                  "title": "Labor",
                                  "name": "No- Permanent (01)",
                                  "type": "staff",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-record-civil-np-painter",
                                      "title": "No- Permanent",
                                      "name": "Painter (1), Helper (1), Scaffolder (2)",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": [
                                        {
                                          "id": "taj-record-civil-np-carpenter",
                                          "title": "Non-Permanent",
                                          "name": "Carpenter (2), Driver (1), Welder (1), Welder Helper (1)",
                                          "type": "staff",
                                          "isVacant": false,
                                          "children": []
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "taj-record-design-services-dept",
                      "title": "Design Services, Building Control & Enforcement",
                      "name": "",
                      "type": "department",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-record-design-hod-asim",
                          "title": "HOD",
                          "name": "Asim Ajaz",
                          "type": "management",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-record-design-mep-riasat",
                              "title": "MEP Autocad Operator",
                              "name": "Riasat Ali",
                              "type": "staff",
                              "isVacant": false,
                              "children": [
                                {
                                  "id": "taj-record-design-doc-qurat",
                                  "title": "Document Controler",
                                  "name": "Qurat ul Ain",
                                  "type": "staff",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-record-design-trainee-muneeb",
                                      "title": "Trainee AutoCAD Operator",
                                      "name": "Muneeb Faraz",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": []
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "taj-record-admin-dept",
                      "title": "Admin",
                      "name": "",
                      "type": "department",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-record-admin-dispenser",
                          "title": "Dispenser",
                          "name": "Liaqat Ali",
                          "type": "staff",
                          "isVacant": false,
                          "children": [
                            {
                              "id": "taj-record-admin-horse",
                              "title": "Horse Care taker",
                              "name": "(1)",
                              "type": "staff",
                              "isVacant": false,
                              "children": [
                                {
                                  "id": "taj-record-admin-mosque-dept",
                                  "title": "Mosque",
                                  "name": "",
                                  "type": "department",
                                  "isVacant": false,
                                  "children": [
                                    {
                                      "id": "taj-record-mosque-khateeb",
                                      "title": "Khateeb/Imam",
                                      "name": "(3)",
                                      "type": "staff",
                                      "isVacant": false,
                                      "children": [
                                        {
                                          "id": "taj-record-mosque-moazzan",
                                          "title": "Moazzan",
                                          "name": "(1)",
                                          "type": "staff",
                                          "isVacant": false,
                                          "children": [
                                            {
                                              "id": "taj-record-mosque-caretaker",
                                              "title": "Caretaker/Khadim",
                                              "name": "(1)",
                                              "type": "staff",
                                              "isVacant": false,
                                              "children": [
                                                {
                                                  "id": "taj-record-mosque-cleaner",
                                                  "title": "Cleaner",
                                                  "name": "(1)",
                                                  "type": "staff",
                                                  "isVacant": false,
                                                  "children": []
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "id": "taj-record-billing-dept",
                      "title": "Billing and Recovery",
                      "name": "",
                      "type": "department",
                      "isVacant": false,
                      "children": [
                        {
                          "id": "taj-record-billing-eng-hasnain",
                          "title": "Electrical Eng",
                          "name": "Hasnain Tahir",
                          "type": "staff",
                          "isVacant": false,
                          "children": []
                        }
                      ]
                    },
                    {
                      "id": "taj-record-call-center",
                      "title": "Call Center",
                      "name": "",
                      "type": "department",
                      "isVacant": false,
                      "children": []
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "political-team",
      "title": "Political Team",
      "name": "",
      "type": "project",
      "isVacant": false,
      "children": [
        {
          "id": "political-team-officer",
          "title": "Officer",
          "name": "Ghulam Ullah Baloch",
          "type": "management",
          "isVacant": false,
          "children": []
        },
        {
          "id": "political-team-media-secretary",
          "title": "Media Secretary",
          "name": "M. Naveed",
          "type": "management",
          "isVacant": false,
          "children": []
        },
        {
          "id": "political-team-assistant",
          "title": "Assistant",
          "name": "Umar Farooq",
          "type": "staff",
          "isVacant": false,
          "children": []
        },
        {
          "id": "political-team-typist",
          "title": "Typist",
          "name": "Naeem Afzal",
          "type": "staff",
          "isVacant": false,
          "children": []
        },
        {
          "id": "political-team-internal-auditor",
          "title": "Internal Auditor",
          "name": "Sardar Iftikahar",
          "type": "management",
          "isVacant": false,
          "children": []
        },
        {
          "id": "political-team-manager",
          "title": "Manager",
          "name": "Imran Yaseen",
          "type": "management",
          "isVacant": false,
          "children": []
        },
        {
          "id": "political-team-qari",
          "title": "Qari",
          "name": "Ateq U Din",
          "type": "staff",
          "isVacant": false,
          "children": []
        },
        {
          "id": "political-team-guard",
          "title": "Guard",
          "name": "Ishaq",
          "type": "staff",
          "isVacant": false,
          "children": []
        },
        {
          "id": "political-team-deputy-manager-media",
          "title": "Deputy Manager Media",
          "name": "Kaleem Arbab",
          "type": "management",
          "isVacant": false,
          "children": []
        }
      ]
    },
    {
      "id": "president-s-research-cell-152",
      "title": "President's Research CELL",
      "name": "",
      "type": "project",
      "isVacant": false,
      "children": [
        {
          "id": "research-officer-220",
          "title": "Research officer",
          "name": "Kamran Yousaf",
          "type": "management",
          "isVacant": false,
          "children": []
        },
        {
          "id": "research-assistant-hafiz-zafar",
          "title": "Assistant",
          "name": "Hafiz Zafar",
          "type": "staff",
          "isVacant": false,
          "children": []
        },
        {
          "id": "research-assistant-bilal-yousaf",
          "title": "Assistant",
          "name": "Bilal Yousaf",
          "type": "staff",
          "isVacant": false,
          "children": []
        }
      ]
    },
    {
      "id": "president-s-media-cell-153",
      "title": "President's Media Cell",
      "name": "",
      "type": "project",
      "isVacant": false,
      "children": [
        {
          "id": "social-media-head-154",
          "title": "Social Media Head",
          "name": "Raza",
          "type": "management",
          "isVacant": false,
          "children": []
        },
        {
          "id": "video-editor-156",
          "title": "Video Editor",
          "name": "Saad Saeed",
          "type": "staff",
          "isVacant": false,
          "children": []
        },
        {
          "id": "content-writer-157",
          "title": "Content Writer",
          "name": "Yousaf Saeed",
          "type": "staff",
          "isVacant": false,
          "children": []
        },
        {
          "id": "photographer-ehtisham",
          "title": "Photographer",
          "name": "Ehtisham Mehmood",
          "type": "staff",
          "isVacant": false,
          "children": []
        },
        {
          "id": "photographer-irfan",
          "title": "Photographer",
          "name": "Irfan",
          "type": "staff",
          "isVacant": false,
          "children": []
        },
        {
          "id": "non-liner-video-editor-158",
          "title": "Non liner video editor",
          "name": "Jamal Rasheed",
          "type": "staff",
          "isVacant": false,
          "children": []
        }
      ]
    },
    {
      "id": "president-secretariat",
      "title": "President Secretariat",
      "name": "",
      "type": "project",
      "isVacant": false,
      "children": [
        {
          "id": "principal-secretary-president",
          "title": "Principal secretary to President",
          "name": "Lt. COL Ishfaq Ahmad",
          "type": "management",
          "isVacant": false,
          "children": []
        },
        {
          "id": "president-secretariat-assistant",
          "title": "Assistant",
          "name": "",
          "type": "staff",
          "isVacant": true,
          "children": []
        },
        {
          "id": "president-secretariat-sr-manager-coord",
          "title": "Sr. Manager Coord.",
          "name": "",
          "type": "management",
          "isVacant": true,
          "children": []
        },
        {
          "id": "president-secretariat-manager-operation",
          "title": "Manager Operation",
          "name": "Afif Saghir",
          "type": "management",
          "isVacant": false,
          "children": []
        }
      ]
    },
    {
      "id": "ceo-secretariat",
      "title": "CEO Secretariat",
      "name": "",
      "type": "project",
      "isVacant": false,
      "children": [
        {
          "id": "ceo-secretariat-coordinator",
          "title": "Coordinator",
          "name": "Wajahat Haleem",
          "type": "management",
          "isVacant": false,
          "children": []
        },
        {
          "id": "ceo-secretariat-architect",
          "title": "Architect",
          "name": "Hasnain",
          "type": "staff",
          "isVacant": false,
          "children": []
        },
        {
          "id": "ceo-secretariat-supervisor",
          "title": "Supervisor",
          "name": "Faisal Abbasi",
          "type": "management",
          "isVacant": false,
          "children": []
        },
        {
          "id": "ceo-secretariat-site-engineer",
          "title": "Site Engineer",
          "name": "Junaid",
          "type": "staff",
          "isVacant": false,
          "children": []
        },
        {
          "id": "ceo-secretariat-carpenter",
          "title": "Carpenter",
          "name": "Bacha Rehman",
          "type": "staff",
          "isVacant": false,
          "children": []
        },
        {
          "id": "ceo-secretariat-care-taker",
          "title": "Care Taker",
          "name": "Ibrar",
          "type": "staff",
          "isVacant": false,
          "children": []
        }
      ]
    }
  ]
};

export default SGC_ORG_CHART;
